function initGlobalSwipers() {
  if (typeof Swiper === 'undefined') {
    setTimeout(initGlobalSwipers, 100);
    return;
  }

  if (document.querySelector('.swiperHero:not(.swiper-initialized)')) {
    new Swiper('.swiperHero', {
      loop: true,
      effect: "fade",
      autoplay: {
        delay: 3000,
      },
    });
  }

  if (document.querySelector('.sliderText:not(.swiper-initialized)')) {
    new Swiper(".sliderText", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGlobalSwipers);
} else {
  initGlobalSwipers();
}

// Custom Accordion functionality
function initAccordions() {
  // Set initial height for active items (like the first one)
  document.querySelectorAll('.custom-product-accordion .accordion-item.active').forEach(function(item) {
    const content = item.querySelector('.accordion-content');
    if (content) {
      content.style.display = 'block';
      content.style.maxHeight = 'none';
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAccordions);
} else {
  initAccordions();
}

// Global click handler using event delegation
document.addEventListener('click', function(e) {
  const header = e.target.closest('.custom-product-accordion .js-accordion-trigger');
  if (!header) return;

  e.preventDefault();

  const item = header.closest('.accordion-item');
  if (!item) return;

  const content = item.querySelector('.accordion-content');
  const isAlreadyActive = item.classList.contains('active');
  const container = item.closest('.custom-product-accordion');

  // Close all other accordion items in the same container
  if (container) {
    container.querySelectorAll('.accordion-item').forEach(function(otherItem) {
      if (otherItem !== item) {
        otherItem.classList.remove('active');
        const otherHeader = otherItem.querySelector('.accordion-header');
        if (otherHeader) otherHeader.setAttribute('aria-expanded', 'false');
        const otherContent = otherItem.querySelector('.accordion-content');
        if (otherContent) {
          otherContent.style.maxHeight = otherContent.scrollHeight + 'px';
          otherContent.offsetHeight; // Force reflow
          otherContent.style.maxHeight = '0';
          setTimeout(() => {
            if (!otherItem.classList.contains('active')) {
              otherContent.style.display = 'none';
            }
          }, 350);
        }
      }
    });
  }

  if (isAlreadyActive) {
    // Close current item
    item.classList.remove('active');
    header.setAttribute('aria-expanded', 'false');
    if (content) {
      content.style.maxHeight = content.scrollHeight + 'px';
      content.offsetHeight; // Force reflow
      content.style.maxHeight = '0';
      setTimeout(() => {
        if (!item.classList.contains('active')) {
          content.style.display = 'none';
        }
      }, 350);
    }
  } else {
    // Open current item
    item.classList.add('active');
    header.setAttribute('aria-expanded', 'true');
    if (content) {
      content.style.display = 'block';
      content.offsetHeight; // Force reflow
      content.style.maxHeight = content.scrollHeight + 'px';
      setTimeout(() => {
        if (item.classList.contains('active')) {
          content.style.maxHeight = 'none';
        }
      }, 350);
    }
  }
});

// Smooth scroll for similar products button
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a.button-block[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const targetEl = document.querySelector(targetId);
      if (targetEl) {
        targetEl.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});

// Header cart & mobile navigation slideout drawer click handlers
(function() {
  document.addEventListener('click', function(e) {
    // 1. Check if click originated from or was targeted at the Cart icon / trigger
    const cartTrigger = e.target.closest('.js-mini-cart-trigger, [data-wau-slideout-target="ajax-cart"], .cart-links__link-cart, .my-cart-link-container');
    if (cartTrigger) {
      const cartDrawer = document.querySelector('aside[data-wau-slideout="ajax-cart"], [data-wau-modal="ajax-cart"]');
      if (cartDrawer) {
        // Prevent default anchor link navigation to /cart so the drawer/modal can open
        e.preventDefault();

        // If the cart drawer is not already active, trigger opening via theme Slideout/Modal
        const isCartActive = cartDrawer.classList.contains('slideout--active') || cartDrawer.classList.contains('modal--active');
        if (!isCartActive) {
          if (window.WAU && window.WAU.Slideout && typeof window.WAU.Slideout._openByName === 'function') {
            try {
              window.WAU.Slideout._openByName('ajax-cart');
            } catch (err) {
              console.warn('WAU.Slideout._openByName ajax-cart failed:', err);
            }
          }
        }
      }
      // CRITICAL: Stop here so that cart clicks NEVER evaluate or trigger menu drawer logic
      return;
    }

    // 2. Mobile navigation open trigger (dedicated menu/hamburger only)
    const openTrigger = e.target.closest('.mobile-menu__trigger [data-wau-slideout-target="mobile-navigation"], .mobile-menu__trigger button, [data-wau-slideout-target="mobile-navigation"]');
    if (openTrigger) {
      // Guard against any cart triggers
      if (openTrigger.closest('.my-cart-link-container, .cart-links__link-cart') || openTrigger.matches('[data-wau-slideout-target="ajax-cart"], .js-mini-cart-trigger')) {
        return;
      }

      const drawer = document.querySelector('aside[data-wau-slideout="mobile-navigation"], #slideout-mobile-navigation');
      const bodyWrapper = document.querySelector('.js-slideout-toggle-wrapper') || document.body;

      if (drawer && drawer.classList.contains('slideout--active') && bodyWrapper.classList.contains('slideout-left--open')) {
        return; // Already opened by theme listener
      }

      e.preventDefault();

      if (window.WAU && window.WAU.Slideout && typeof window.WAU.Slideout._openByName === 'function') {
        try {
          window.WAU.Slideout._openByName('mobile-navigation');
          return;
        } catch (err) {
          console.warn('WAU.Slideout._openByName failed, using fallback:', err);
        }
      }

      // Fallback drawer open logic
      if (drawer && bodyWrapper) {
        bodyWrapper.classList.add('slideout-left--open');
        bodyWrapper.classList.remove('slideout-left--closed');
        drawer.classList.add('slideout--active');
        openTrigger.setAttribute('aria-expanded', 'true');
        drawer.querySelectorAll('*').forEach(function(item) {
          item.removeAttribute('tabIndex');
        });
      }
      return;
    }

    // 3. Mobile navigation close trigger
    const closeTrigger = e.target.closest('#slideout-mobile-navigation .js-slideout-close, .mobile-menu button.js-slideout-close, .mobile-menu .slideout__trigger-mobile-menu.js-slideout-close');
    if (closeTrigger) {
      const drawer = document.querySelector('aside[data-wau-slideout="mobile-navigation"], #slideout-mobile-navigation');
      const bodyWrapper = document.querySelector('.js-slideout-toggle-wrapper') || document.body;

      if (drawer && !drawer.classList.contains('slideout--active')) {
        return; // Already closed
      }

      e.preventDefault();

      if (window.WAU && window.WAU.Slideout && typeof window.WAU.Slideout._closeByName === 'function') {
        try {
          window.WAU.Slideout._closeByName('mobile-navigation');
          return;
        } catch (err) {
          console.warn('WAU.Slideout._closeByName failed, using fallback:', err);
        }
      }

      // Fallback drawer close logic
      if (drawer && bodyWrapper) {
        bodyWrapper.classList.remove('slideout-left--open');
        bodyWrapper.classList.add('slideout-left--closed');
        drawer.classList.remove('slideout--active');
        drawer.querySelectorAll('*').forEach(function(item) {
          item.setAttribute('tabIndex', '-1');
        });
        const opener = document.querySelector('.mobile-menu__trigger [data-wau-slideout-target="mobile-navigation"], .mobile-menu__trigger button.js-slideout-open, button.slideout__trigger-mobile-menu.js-slideout-open');
        if (opener) {
          opener.setAttribute('aria-expanded', 'false');
          opener.focus();
        }
      }
      return;
    }
  });
})();

// ==========================================================================
// REDESIGNED CART DRAWER INTERACTIVITY
// ==========================================================================
(function() {
  // 1. Variant selection change in "You may also like"
  document.addEventListener('change', function(e) {
    if (e.target.matches('.js-rec-variant-select')) {
      const select = e.target;
      const card = select.closest('.cart-drawer__rec-card');
      if (!card) return;

      const selectedOpt = select.options ? select.options[select.selectedIndex] : null;
      if (!selectedOpt) return;

      const priceEl = card.querySelector('.js-rec-price');
      const compareEl = card.querySelector('.js-rec-compare');
      const addBtn = card.querySelector('.js-rec-add-btn');

      if (priceEl && selectedOpt.dataset.price) {
        priceEl.textContent = selectedOpt.dataset.price;
      }

      if (compareEl) {
        if (selectedOpt.dataset.compare && selectedOpt.dataset.compare.trim() !== '') {
          compareEl.innerHTML = '<s>' + selectedOpt.dataset.compare + '</s>';
          compareEl.classList.remove('hide');
        } else {
          compareEl.innerHTML = '';
          compareEl.classList.add('hide');
        }
      }

      if (addBtn) {
        addBtn.setAttribute('data-variant-id', select.value);
      }
    }
  });

  // 2. Add to cart for "You may also like"
  document.addEventListener('click', function(e) {
    const addBtn = e.target.closest('.js-rec-add-btn');
    if (!addBtn) return;

    e.preventDefault();
    const card = addBtn.closest('.cart-drawer__rec-card');
    let variantId = addBtn.getAttribute('data-variant-id');
    if (!variantId && card) {
      const select = card.querySelector('.js-rec-variant-select');
      if (select) variantId = select.value;
    }
    if (!variantId) return;

    const originalText = addBtn.textContent;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding...';

    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(item => {
      addBtn.textContent = 'Added!';
      setTimeout(() => {
        addBtn.disabled = false;
        addBtn.textContent = originalText;
      }, 1500);

      // Refresh cart view
      let config = document.getElementById('cart-config');
      if (config) {
        try { config = JSON.parse(config.innerHTML || '{}'); } catch(e) { config = {}; }
      } else {
        config = { cart_url: '/cart', cart_action: 'drawer' };
      }

      if (window.Shopify && window.Shopify.theme && window.Shopify.theme.cart && window.Shopify.theme.ajaxCart) {
        window.Shopify.theme.cart.getCart().then(Cart => {
          window.Shopify.theme.ajaxCart.updateView(config, Cart);
        });
      } else {
        // Fallback: fetch ajax view
        fetch('/cart/?view=ajax')
          .then(res => res.text())
          .then(html => {
            const temp = document.createElement('div');
            temp.innerHTML = html;
            const contentEl = temp.querySelector('[data-html="content"]');
            const pageEl = temp.querySelector('[data-html="page"]');
            const drawerEl = temp.querySelector('[data-html="drawer"]');
            document.querySelectorAll('.js-ajax-cart-content').forEach(wrapper => {
              if (wrapper.closest('.ajax-cart__page-wrapper') && pageEl) {
                wrapper.innerHTML = pageEl.innerHTML;
              } else if (wrapper.closest('.ajax-cart__drawer-wrapper') && drawerEl) {
                wrapper.innerHTML = drawerEl.innerHTML;
              } else if (contentEl) {
                wrapper.innerHTML = contentEl.innerHTML;
              }
            });
          });
      }
    })
    .catch(err => {
      console.error('Error adding recommended product to cart:', err);
      addBtn.disabled = false;
      addBtn.textContent = originalText;
    });
  });

  // 3. Carousel navigation for "You may also like"
  document.addEventListener('click', function(e) {
    const prevBtn = e.target.closest('.cart-drawer__rec-prev');
    const nextBtn = e.target.closest('.cart-drawer__rec-next');
    if (!prevBtn && !nextBtn) return;

    e.preventDefault();
    const section = (prevBtn || nextBtn).closest('.cart-drawer__rec-section');
    if (!section) return;

    const slides = section.querySelectorAll('.cart-drawer__rec-slide');
    if (slides.length <= 1) return;

    let activeIdx = 0;
    slides.forEach((slide, idx) => {
      if (slide.classList.contains('active')) {
        activeIdx = idx;
      }
    });

    if (prevBtn) {
      activeIdx = (activeIdx - 1 + slides.length) % slides.length;
    } else {
      activeIdx = (activeIdx + 1) % slides.length;
    }

    slides.forEach((slide, idx) => {
      if (idx === activeIdx) {
        slide.classList.add('active');
      } else {
        slide.classList.remove('active');
      }
    });
  });

  // 4. Close button handler for cart drawer
  document.addEventListener('click', function(e) {
    const closeBtn = e.target.closest('.cart-drawer__close-btn');
    if (closeBtn) {
      e.preventDefault();
      if (window.WAU && window.WAU.Slideout && typeof window.WAU.Slideout._closeByName === 'function') {
        window.WAU.Slideout._closeByName('ajax-cart');
      } else {
        const bodyWrapper = document.querySelector('.js-slideout-toggle-wrapper') || document.body;
        const drawer = document.getElementById('slideout-ajax-cart');
        if (bodyWrapper) {
          bodyWrapper.classList.remove('slideout-right--open');
          bodyWrapper.classList.add('slideout-right--closed');
        }
        if (drawer) {
          drawer.classList.remove('slideout--active');
        }
      }
    }
  });
})();

// ==========================================================================
// ==========================================================================
// PDP QUANTITY → CART: Exact quantity sync & Custom Options / Engraving Support
// Ensures the exact quantity selected on the PDP is added/updated in the cart,
// while allowing active engraving/customization options to process cleanly.
// ==========================================================================
(function() {

  function hasActiveEngraving(section) {
    var sec = section || document.querySelector('.product__section');
    if (!sec) return false;

    // Check if any engraving/customization text field has actual user input
    var textInputs = sec.querySelectorAll('input[name*="Engrave"], input[name*="engrav"], input[name*="Personalization"], input[data-product-property], .easify-product-options input[type="text"], .easify-product-options textarea');
    for (var i = 0; i < textInputs.length; i++) {
      if (textInputs[i].value && textInputs[i].value.trim() !== '') {
        return true;
      }
    }

    // Check if any engraving/addon checkbox or radio is actively checked
    var checkedInputs = sec.querySelectorAll('.easify-product-options input[type="checkbox"]:checked, .easify-product-options input[type="radio"]:checked');
    for (var j = 0; j < checkedInputs.length; j++) {
      var val = checkedInputs[j].value ? checkedInputs[j].value.toLowerCase().trim() : '';
      if (val && val !== 'none' && val !== 'no' && val !== '0' && val !== 'false') {
        return true;
      }
    }

    return false;
  }

  function getPDPQtyAndVariant(btn) {
    var form = btn.closest('form');
    if (!form) return null;

    var section = form.closest('.product__section') || document.querySelector('.product__section');
    var visibleQty = section
      ? section.querySelector('.formQty:not([type="hidden"]), input.quantity:not([type="hidden"]), input[name="quantity"]:not([type="hidden"])')
      : null;
    if (!visibleQty && form.id) {
      visibleQty = document.querySelector('input[name="quantity"][form="' + form.id + '"]:not([type="hidden"]), .formQty[form="' + form.id + '"]:not([type="hidden"])');
    }

    var variantInput = form.querySelector('input[name="id"]:checked, input[type="hidden"][name="id"], select[name="id"]') ||
                       (section ? section.querySelector('.formVariantId[value], input[name="id"]') : null);

    if (!visibleQty || !variantInput || !variantInput.value) return null;

    var qty = parseInt(visibleQty.value, 10);
    var variantId = parseInt(variantInput.value, 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    if (isNaN(variantId) || !variantId) return null;

    return { qty: qty, variantId: variantId, form: form, btn: btn, section: section };
  }

  function getCartConfig() {
    var cfg = document.getElementById('cart-config');
    if (!cfg) return {};
    try { return JSON.parse(cfg.innerHTML || '{}'); } catch(e) { return {}; }
  }

  function refreshCartDrawer(config) {
    if (!window.Shopify || !Shopify.theme) return;
    config = config || getCartConfig();
    Shopify.theme.cart.getCart().then(function(Cart) {
      Shopify.theme.ajaxCart.updateView(config, Cart);
      if (config.cart_action === 'drawer') {
        Shopify.theme.ajaxCart.showDrawer(config);
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: Cart } }));
    });
  }

  function setButtonState(btn, loading) {
    if (loading) {
      btn._pdpOrigText = btn.value || btn.textContent;
      if (btn.tagName === 'INPUT') btn.value = 'Adding...';
      else btn.textContent = 'Adding...';
      btn.disabled = true;
      btn.classList.add('disabled');
    } else {
      if (btn.tagName === 'INPUT') btn.value = btn._pdpOrigText || 'Add to Cart';
      else btn.textContent = btn._pdpOrigText || 'Add to Cart';
      btn.disabled = false;
      btn.classList.remove('disabled');
    }
  }

  // Intercept cart/add.js fetch calls so cart drawer always updates when apps (e.g. Easify engraving) add items
  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function() {
      var args = arguments;
      var url = args[0];
      var isCartAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;

      var result = originalFetch.apply(this, args);
      if (isCartAdd) {
        result.then(function(response) {
          if (response && response.ok) {
            setTimeout(function() {
              refreshCartDrawer(getCartConfig());
            }, 350);
          }
        }).catch(function() {});
      }
      return result;
    };
  }

  function isItemCustomized(item) {
    if (!item || !item.properties) return false;
    var props = item.properties;
    if (Array.isArray(props)) {
      return props.some(function(p) {
        var key = p.name || p.first || '';
        var val = p.value || p.last || '';
        return key && val && !String(key).startsWith('_');
      });
    } else if (typeof props === 'object') {
      for (var k in props) {
        if (props.hasOwnProperty(k) && !String(k).startsWith('_')) {
          var v = props[k];
          if (v !== null && v !== undefined && String(v).trim() !== '') {
            return true;
          }
        }
      }
    }
    return false;
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.js-ajax-submit');
    if (!btn) return;

    // Only intercept PDP product section buttons (not quick-add or cart buttons)
    if (!btn.closest('.product__section')) return;

    var info = getPDPQtyAndVariant(btn);
    if (!info) return;

    // If product has active engraving entered by user, let the option handler process both items
    if (hasActiveEngraving(info.section)) {
      return;
    }

    // Stop theme's default handler so we can ensure the EXACT PDP quantity is added/updated in the cart
    e.stopImmediatePropagation();
    e.preventDefault();

    var targetQty  = info.qty;
    var variantId  = info.variantId;
    var config     = getCartConfig();
    var rootUrl    = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

    // Synchronize target quantity to all inputs in section and form
    if (info.section) {
      info.section.querySelectorAll('.formQty, input[name="quantity"]').forEach(function(inp) {
        inp.value = targetQty;
        inp.setAttribute('value', targetQty);
      });
    }

    setButtonState(btn, true);

    // 1. Get current cart to check if normal (non-engraved) variant already exists
    fetch(rootUrl + 'cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var existing = null;
        (cart.items || []).forEach(function(item) {
          // Only match an existing un-customized/normal item; do NOT merge into an engraved item
          if (item.variant_id === variantId && !isItemCustomized(item) && !existing) {
            existing = item;
          }
        });

        if (existing) {
          // Normal variant already in cart — UPDATE to exact qty
          return fetch(rootUrl + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: existing.key, quantity: targetQty })
          });
        } else {
          // Not in cart (or only engraved item exists) — ADD normal product as separate line item with selected qty
          var formData = new FormData(info.form);
          formData.delete('quantity');
          formData.set('quantity', String(targetQty));
          return fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });
        }
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Cart request failed: ' + response.status);
        return response.json();
      })
      .then(function() {
        setButtonState(btn, false);
        refreshCartDrawer(config);
      })
      .catch(function(err) {
        console.error('PDP qty-to-cart error:', err);
        setButtonState(btn, false);
      });

  }, true); // capture phase

})();

// ==========================================================================
// CART PAGE LOADER DISMISSER
// Ensures any fixed loading-wrapper overlay on the cart page is cleanly dismissed
// ==========================================================================
(function() {
  function dismissCartLoaders() {
    var loaders = document.querySelectorAll('.ajax-cart__page-wrapper .js-mini-cart-loader, .cart-page .js-mini-cart-loader, body.template-cart .loading-wrapper');
    loaders.forEach(function(loader) {
      if (loader && loader.style.display !== 'none') {
        loader.style.transition = 'opacity 0.3s ease, visibility 0.3s ease';
        loader.style.opacity = '0';
        loader.style.visibility = 'hidden';
        setTimeout(function() {
          loader.style.display = 'none';
        }, 300);
      }
    });
  }

  // Dismiss on DOM ready, window load, and after brief delay
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(dismissCartLoaders, 300);
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(dismissCartLoaders, 300);
    });
  }
  window.addEventListener('load', function() {
    setTimeout(dismissCartLoaders, 100);
  });
  setTimeout(dismissCartLoaders, 1200);
})();


